export default {
  list: {
    columns: [
      { key: 'key', width: 200 },
      { key: 'name', width: 300 },
      { key: 'supplierRef', width: 150 },
      { key: 'salePrice', width: 100 },
      { key: 'staffPrice', width: 100 },
      { key: 'storeCost', width: 100 },
      { key: 'centerCost', width: 100 },
      { key: 'brandCode', width: 100 },
      { key: 'seriesRef', width: 200 },
    ],
    query: {
      fixedQuery: {
        type: { $eq: 'C' },
      },
    },
  },
  editor: {
    config: { titleSm: 2, titleMd: 1 },
    groups: [
      {
        name: '商品',
        rows: [
          [{ key: 'key' }],
          [{ key: 'name' }],
          [{ key: 'type' }],
          [{ key: 'brandCode' }, { key: 'brandRef' }],
          [{ key: 'supplierRef' }, { key: 'orderCode' }],
          [{ key: 'unit' }],
          [{ key: 'origin' }],
          [{ key: 'note' }],
          [{ key: 'isContract' }],
          [{ key: 'orderFrom' }],
          [{ key: 'payType' }],
          [{ key: 'spec' }],
          [{ key: 'taxType' }],
          [{ key: 'basicAmount' }],
          [{ key: 'ragicStoreNodeId' }, { key: 'ragicCenterNodeId' }],
        ],
      },
      {
        name: '成本',
        rows: [
          [{ key: 'centerCost' }],
          [{ key: 'storeCost' }],
        ],
      },
      {
        name: '價格',
        rows: [
          [{ key: 'price' }],
          [{ key: 'staffPrice' }],
          [{ key: 'salePrice' }],
        ],
      },
      {
        name: '規格 - C 類',
        rows: [
          [{ key: 'seriesRef' }],
          [{ key: 'radius' }],
          [{ key: 'replacementFrequency' }],
          [{ key: 'lensColor' }],
          [{ key: 'Ctype' }],
          [{ key: 'waterContent' }, { key: 'diameter' }],
          [{ key: 'packingQuantity' }],
          [{ key: 'sphereMax' }, { key: 'sphereMin' }],
          [{ key: 'cylinderMax' }, { key: 'cylinderMin' }],
          [{ key: 'axisMax' }, { key: 'axisMin' }],
          [{ key: 'addMax' }, { key: 'addMin' }],
          [{ key: 'SCMax' }],
        ],
      },
    ],
  },
}



// WEBPACK FOOTER //
// ./src/views/ui/productsC.js